import React from 'react';

function WorkerTracking() {
  return <div className="page-container"><h1>Worker Tracking</h1><p>GPS tracking view coming soon...</p></div>;
}

export default WorkerTracking;
